<template>
  <b-sidebar
    id="message-sidebar"
    shadow
    title="Your messages"
    backdrop-variant="dark"
    v-model="$events.sidebar.show"
  >
    <b-list-group>
      <b-list-group-item
        class="d-flex justify-content-between align-items-start"
        v-for="message in $events.data"
        :key="message.id"
      >
        {{
          new Intl.DateTimeFormat($i18n.locale, {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          }).format(new Date(message.date))
        }}<br /><br />
        {{ message.message }}
        <b-button size="sm" variant="light" @click="removeMessage(message.id)"
          ><b-icon icon="x-circle-fill"
        /></b-button>
      </b-list-group-item>
    </b-list-group>
  </b-sidebar>
</template>

<script>

export default {
  name: "CompSidebar",
  data() {
    return {};
  },
  methods: {
    removeMessage(id) {
      let idx = this.$events.data.findIndex((e) => e.id === id);
      if (idx > -1) {
        this.$events.data.splice(idx, 1);
        if (this.$events.data.length === 0) {
          this.$events.sidebar.show = false;
        }
      }
    },
  },
  created() {},
};
</script>